import WhatsappCard from '../../../../../pages/vip/features/whatsapp-card/whatsapp-card';

export default WhatsappCard;
